module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/weight-2-b57a2f21e5926ed6e690e986bd2fd8e7.svg";